import { render, staticRenderFns } from "./theserver.vue?vue&type=template&id=a368b8cc"
import script from "./theserver.vue?vue&type=script&lang=js"
export * from "./theserver.vue?vue&type=script&lang=js"
import style0 from "./theserver.vue?vue&type=style&index=0&id=a368b8cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports